<template>
  <div class="main">
    <div class="content">
    <div class="con" style="margin-top:10px">
        <el-form
        ref="form"
        label-width="100px"
        style="overflow: hidden;padding-top:5px"
        :show-message="false"
      >
        <el-col :span="24">
          <el-form-item label="影像资源" required>
            <el-button
              size="small"
              type="primary"
              @click="select()"
            >选择检查</el-button>
            <ul class="jc-list">
              <li v-for="(v, index) in studyData" :key="v.studyUuid">
                资源{{index + 1}}
                <img class="success" src="../../../assets/images/success.png" alt="">
              </li>
            </ul>
          </el-form-item>
        </el-col>
      </el-form>
    </div>
    <div class="con" style="margin-top:15px">
      <el-form
        ref="baseForm"
        :model="baseformData"
        label-width="100px"
        style="overflow: hidden;padding-top:5px;padding-right:5px;"
        :show-message="false"
      >
        <el-col :span="12">
          <el-form-item label="病例标题" prop="title" required>
            <el-input v-model="baseformData.title" :maxlength="50" placeholder="请输入" show-word-limit></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="题目难度" prop="level" required>
            <el-select
              :style="{width: '100%'}"
              v-model="baseformData.level"
              placeholder="请选择题型模板"
            >
              <el-option v-for="(item,i) in questionLevel" :key="i" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="课程目录" prop="directoryId">
            <el-cascader ref="cascader" style="width:100%" :popper-append-to-body="false" popper-class="custom-dropdown"
              v-model="baseformData.directoryId"
              :show-all-levels="false" clearable filterable
              :props="props" :options="directoryList"
              ></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="关键字" required :show-message="!baseformData.keys">
            <label-input @on-change="changeKey" :parentarr="getKey" ref="labelInput" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="适合专业">
            <el-checkbox-group v-model="baseformData.profession" @change="updateProfessionName">
              <el-checkbox :label="val.id" v-for="val in professionData" :key="val.id">{{val.dictionaryName}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-form>
    </div>
    <div class="con">
      <h1 class="h1">患者申请单</h1>
      <el-form
        ref="hzsqdForm"
        label-position="left"
        :model="hzsqdForm"
        label-width="auto"
      >
      <el-form-item label="基本信息：">
        <div class="person-base-message">
          <p class="p">
            <span class="name">患者</span>
            <el-select
              v-model="hzsqdForm.patGender"
              placeholder="请选择"
            >
              <el-option v-for="(item,i) in genderData" :key="i" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <el-input class="year" placeholder="如：11Y5M" v-model="hzsqdForm.patAge"></el-input>
            <!-- <el-input class="month" v-model="hzsqdForm.checkPoint"></el-input>M -->
          </p>
        </div>
      </el-form-item>
      <el-form-item label="检查部位：">
        <div><p class="p"><el-input v-model="hzsqdForm.checkPoint" class="text-input" type="textarea" :maxlength="500" show-word-limit rows="3"></el-input></p></div>
      </el-form-item>
      <el-form-item label="临床诊断：">
        <div><p class="p"><el-input v-model="hzsqdForm.clinic" class="text-input" type="textarea" :maxlength="500" show-word-limit rows="3"></el-input></p></div>
      </el-form-item>
      <el-form-item label="检查目的：">
        <div><p class="p"><el-input v-model="hzsqdForm.studyDest" class="text-input" type="textarea" :maxlength="500" show-word-limit rows="3"></el-input></p></div>
      </el-form-item>
      <el-form-item label="病例摘要：">
        <div><p class="p"><el-input v-model="hzsqdForm.clinicDiagnosis" class="text-input" type="textarea" :maxlength="500" show-word-limit rows="3"></el-input></p></div>
      </el-form-item>
      </el-form>
    </div>
    <div class="con">
      <h1 class="h1">报告单详情</h1>
      <el-form
        :show-message="false"
        ref="reportForm"
        label-position="left"
        :model="reportForm"
        label-width="auto"
      >
      <div class="con-2">
        <el-form-item label="检查类型：" prop="modality" :rules="{ required: true, trigger: 'change' }" class="item1">
          <div>
            <p class="p">
              <el-select
                v-model="reportForm.modality"
                placeholder="请选择"
              >
                <el-option v-for="(item,i) in checkType" :key="i" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </p>
          </div>
        </el-form-item>
        <el-form-item label="检查项目：" class="item2">
          <div><p class="p"><el-input v-model="reportForm.examItem" :maxlength="20" show-word-limit></el-input></p></div>
        </el-form-item>
      </div>
      <el-form-item label="影像学表现：" required prop="finding">
        <div><p class="p"><el-input v-model="reportForm.finding" class="text-input" type="textarea" :maxlength="3000" show-word-limit rows="3"></el-input></p></div>
      </el-form-item>
      <el-form-item label="诊断：" required prop="conclusion">
        <div><p class="p"><el-input v-model="reportForm.conclusion" class="text-input" type="textarea" :maxlength="3000" show-word-limit rows="3"></el-input></p></div>
      </el-form-item>
      <!-- <el-form-item label="影像学表现关键词：" required :show-message="!reportForm.findingKeys">
        <label-input @on-change="changeKeyV1" :parentarr="getKeyV1" ref="labelInput" />
      </el-form-item>
      <el-form-item label="诊断关键词：" required :show-message="!reportForm.conclusionKeys">
        <label-input @on-change="changeKeyV2" :parentarr="getKeyV2" ref="labelInput" />
      </el-form-item> -->
      <el-form-item label="影像学表现关键词：" prop="findingKeys">
        <div><p class="p"><el-input v-model="reportForm.findingKeys" placeholder="若有多个关键词，以中文逗号或英文逗号进行关键字分隔，如关键字1，关键字2" class="text-input" type="textarea" :maxlength="100" show-word-limit rows="2"></el-input></p></div>
      </el-form-item>
      <el-form-item label="诊断关键词：" prop="conclusionKeys">
        <div><p class="p"><el-input v-model="reportForm.conclusionKeys" placeholder="若有多个关键词，以中文逗号或英文逗号进行关键字分隔，如关键字1，关键字2" class="text-input" type="textarea" :maxlength="100" show-word-limit rows="2"></el-input></p></div>
      </el-form-item>
      </el-form>
    </div>
    <div class="con">
      <h1 class="h1">病理报告</h1>
      <el-form
        :show-message="false"
        ref="pathologyReportForm"
        label-position="left"
        :model="pathologyReportForm"
        label-width="86px"
      >
        <el-form-item label="病理诊断：" prop="findingKeys">
          <div><p class="p"><el-input v-model="pathologyReportForm.diagnosis" placeholder="" class="text-input" type="textarea" :maxlength="100" show-word-limit rows="2"></el-input></p></div>
        </el-form-item>
        <el-form-item label="病理解析：" prop="conclusionKeys">
          <div><p class="p"><el-input v-model="pathologyReportForm.analysis" placeholder="" class="text-input" type="textarea" :maxlength="500" show-word-limit rows="2"></el-input></p></div>
        </el-form-item>
        <upload-img :data="pathologyReportForm.UIdata" :key="`${'UploadImg'}_${new Date().getTime()}_${Math.random()}`"></upload-img>
      </el-form>
    </div></div>
    <div class="btns">
      <div style="display:inline-block">
        <el-button type="primary" plain @click="close(true)">取消</el-button>
        <el-button
          type="primary"
          style="width:120px;margin-left: 10px"
          @click="submit(false)"
        >保存</el-button>
        <el-button v-if="!$route.query.id"
          type="primary"
          style="width:120px;"
          @click="submit('next')"
        >保存并下一题</el-button>
      </div>
    </div>
    <Dialog class="select-dicom-dialog"
      v-model="selectDialog" :width="'70%'"
      :title="'选择检查'" :footer="true"
      @confirm="handleConfirm"
    >
      <template slot="dialog-content">
        <SelectDicom  ref="SelectDicom" :studyData="studyData" :detailInfo="detailInfo" @updateStudyData="updateStudyData" />
      </template>
    </Dialog>
  </div>
</template>

<script>
import SelectDicom from './SelectDicom.vue'
import uploadImg from './pageComponents/uploadImg.vue';
import { questionLevel, genderData, checkType } from '@/data/data';
import { caseServer, courseServer, keyServer } from '@/api/api'
export default {
  components: {SelectDicom, uploadImg},
  computed: {
    getKey () {
      return this.baseformData.keys ? this.baseformData.keys.split(';') : []
    },
    getKeyV1 () {
      return this.reportForm.findingKeys ? this.reportForm.findingKeys.split(';') : []
    },
    getKeyV2 () {
      return this.reportForm.conclusionKeys ? this.reportForm.conclusionKeys.split(';') : []
    }
  },
  data () {
    return {
      questionLevel,
      genderData,
      checkType,
      professionData: [],
      props: {
        multiple: false,
        label: 'name',
        value: 'id',
        children: 'subList',
        checkStrictly: true,
        emitPath: false
      },
      directoryList: [],
      resStudyData: [],
      studyData: [],
      selectDialog: false,
      detailInfo: {},
      baseformData: {
        title: '',
        keys: '',
        directoryId: null,
        level: null,
        profession: [],
        professionName: ''
      },
      // 患者申请单
      hzsqdForm: {
        patGender: '',
        patAge: '',
        checkPoint: '', // 检查部位
        clinic: '', // 临床诊断
        studyDest: '', // 检查目的
        clinicDiagnosis: '' // 病例摘要
      },
      // 报告单
      reportForm: {
        modality: '', // 检查类型
        examItem: '', // 检查项目
        conclusion: '', // 影像表现
        finding: '', // 诊断
        conclusionKeys: '', // 影像表现关键词
        findingKeys: '' // 诊断关键词
      },
      pathologyReportForm: {
        diagnosis: '',
        analysis: '',
        UIdata: {
          "controlName":"",
          "controlType":"UploadImg",
          "controlDefValue":"请输入",
          "controlValue":[],
          "isRequired":false,
          "fieldId":""
        }
      },
    }
  },
  methods: {
    getDetail () {
      caseServer.caseDetail({
        studyId: this.$route.query.id
      }).then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.INITresdetail(data)
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    INITresdetail (res) {
      this.detailInfo = res
      this.baseformData = {
        title: res.title,
        keys: res.keys,
        directoryId: res.directoryId,
        level: res.level,
        profession: res.profession ? res.profession.split(',') : [],
        professionName: res.professionName
      }
      // 患者申请单
      this.hzsqdForm = {
        patGender: res.patGender,
        patAge: res.patAge,
        checkPoint: res.checkPoint, // 检查部位
        clinic: res.clinic, // 临床诊断
        studyDest: res.studyDest, // 检查目的
        clinicDiagnosis: res.clinicDiagnosis // 病例摘要
      }
      // 报告单
      this.reportForm = {
        modality: res.modality, // 检查类型
        examItem: res.examItem, // 检查项目
        conclusion: res.conclusion, // 影像表现
        finding: res.finding, // 诊断
        conclusionKeys: res.conclusionKeys, // 影像表现关键词
        findingKeys: res.findingKeys, // 诊断关键词
      }
      this.studyData = res.studyUploadList;
      this.PRINITresdetail(res);
      this.updateProfessionName()
    },
    PRINITresdetail(res) {
      this.pathologyReportForm.diagnosis = res.caseDiagnosis;
      this.pathologyReportForm.analysis = res.caseAnalysis;
      this.pathologyReportForm.UIdata.controlValue = res.caseImgs ? res.caseImgs.split(',').map(v => { return {key: v}}) : [];
      this.pathologyReportForm.UIdata.fieldId = `UploadImg_${new Date().getTime()}_${Math.random()}`;
      this.getfileurl( this.pathologyReportForm.UIdata.controlValue.map(v => v.key),  this.pathologyReportForm.UIdata.controlValue)
    },
    INITParams () {
      if (!this.studyData.length) {
        this.$message.error('请选择检查！')
        return false
      }
      let params = {}
      let studyUuid = this.studyData.map(v => v.studyUuid).join()
      const prForm = {
        caseDiagnosis: this.pathologyReportForm.diagnosis,
        caseAnalysis: this.pathologyReportForm.analysis,
        caseImgs: this.pathologyReportForm.UIdata.controlValue.map(v => v.key).join()
      };
      params = {
        studyUuid,
        ...this.baseformData,
        ...this.hzsqdForm,
        ...this.reportForm,
        profession: this.baseformData.profession.join(','),
        professionName: this.baseformData.professionName,
        ...prForm
      }
      return params
    },
    async submit (isnext) {
      let flag = await this.submitForm('baseForm');
      let flagV1 = await this.submitForm('reportForm');
      if (!flag|| !flagV1) {
        this.$message.error('请检查必填!')
        return
      }
      const params = this.INITParams()
      if (!params) return
      if (this.$route.query.id) {
        caseServer.caseUpdate({
          studyId: this.$route.query.id,
          oldStudyUuid: this.detailInfo.studyUploadList.map(v => v.studyUuid).join(),
          ...params
        }).then(res => {
          const {code, data, message} = res
          if (code === '0') {
            this.$message.success(message)
            this.close(false)
          } else {
            this.$message.error(message)
          }
        }).catch(error => {
          this.$message.error(error.response.data.message)
        })
        return
      }
      caseServer.caseAdd({
        ...params
      }).then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.$message.success(message)
          if (isnext) {
            this.clearForm()
          } else {
            this.close(false)
          }
        } else {
          this.$message.error(message)
        }
      }).catch(error => {
        this.$message.error(error.response.data.message)
      })
    },
    // 弹窗确认的回调
    handleConfirm () {
      // this.$message.success('操作成功！');
      if (!this.resStudyData.length) {
        this.$message.error('请选择数据！')
        return
      }
      this.studyData = this.resStudyData
      this.selectDialog = false
    },
    select () {
      this.selectDialog = true
      this.$nextTick(() => {
        this.$refs.SelectDicom.search()
      })
    },
    updateStudyData (val) {
      this.resStudyData = val
    },
    clearForm () {
      // 患者申请单
      this.hzsqdForm = {
        patGender: '',
        patAge: '',
        checkPoint: '', // 检查部位
        clinic: '', // 临床诊断
        studyDest: '', // 检查目的
        clinicDiagnosis: '' // 病例摘要
      }
      // 报告单
      this.reportForm ={
        modality: '', // 检查类型
        examItem: '', // 检查项目
        conclusion: '', // 影像表现
        finding: '', // 诊断
        conclusionKeys: '', // 影像表现关键词
        findingKeys: '' // 诊断关键词
      }
      this.pathologyReportForm = {
        diagnosis: '',
        analysis: '',
        UIdata: {
          "controlName":"",
          "controlType":"UploadImg",
          "controlDefValue":"请输入",
          "controlValue":[],
          "isRequired":false,
          "fieldId":""
        }
      };
      this.studyData = []
    },
    submitForm (prop) {
      return new Promise((resolve) => {
        this.$refs[prop].validate((valid) => {
          if (valid) {
            resolve(true)
          } else {
            resolve(false)
          }
        });
      })
    },
    changeKey (v) {
      this.$set(this.baseformData, 'keys', v.join(';'));
    },
    changeKeyV1 (v) {
      this.$set(this.reportForm, 'findingKeys', v.join(';'));
    },
    changeKeyV2 (v) {
      this.$set(this.reportForm, 'conclusionKeys', v.join(';'));
    },
    // 课程目录
    selectData () {
      courseServer.profressionDirectory().then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.INITData(data)
          this.directoryList = data
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    // 专业数据
    selectDataV1 () {
      keyServer.profession({
        dictionaryKey: 'profession'
      }).then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.professionData = data
          if (!this.$route.query.id) {
            this.baseformData.profession = this.professionData.map(v => v.id)
            this.updateProfessionName()
          }
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    // 更新 professionName 方法
    updateProfessionName() {
      const selectedIds = this.baseformData.profession;
      const names = this.professionData
        .filter(item => selectedIds.includes(item.id))
        .map(item => item.dictionaryName);
      this.baseformData.professionName = names.join(',');
    },
    INITData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].subList.length < 1) {
          data[i].subList = undefined // subList若为空数组，则将subList设为undefined
        } else {
          this.INITData(data[i].subList) // subList若不为空数组，则继续 递归调用 本方法
        }
      }
    },
    async close (flag) {
      if (flag) {
        this.$confirm('当前页未保存，是否确认继续', '提示', { type: 'warning' }).then(() => {
          window.close()
        })
      } else {
        window.close()
      }
    },
    getfileurl (fileKeys, data) {
      this.$getUrl({
      fileKeys: fileKeys.join()
      }).then(obj => {
        if (obj) {
          data.forEach((e) => {
            if (e) {
              this.$set(e, 'fileUrl', obj[e.key] || '')
            }
          })
        }
      })
    },
  },
  created () {
    this.selectData()
    this.selectDataV1()
    if (this.$route.query.id) {
      this.getDetail()
    }
  }
}
</script>

<style scoped lang='scss'>
/deep/ .el-form-item.is-error .el-input__inner, /deep/.el-form-item.is-error .el-textarea__inner{
  border-color: #DCDFE6;
}
.main{
  text-align: left;
  margin: 0px 10px;
  max-height: calc(100vh - 74px);
  overflow: auto;
  padding-right: 8px;
  margin-right: -2px;
  .content {
    // height: calc(100vh - 100px);
    // overflow: auto;
  }
}
.main-form {
  overflow: hidden;
  margin: 15px 0;
  padding: 15px 20px 0;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 1px 4px 0px rgba(30, 155, 255, 0.3);
}
.con {
  text-align: left;
  overflow: hidden;
//   margin: 90px 0;
  margin-top: 15px;
  padding: 15px 20px 0;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 1px 4px 0px rgba(30, 155, 255, 0.3);
  .jc-list {
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    gap: 12px 12px;
    margin-top: 12px;
    margin-left: -74px;
    li {
      background: rgba(186, 209, 246, 0.0784);
      border-radius: 8px;
      border: 1px solid rgba(186, 209, 246, 0.0784);
      color: #3D3D3D;
      padding: 0px 16px;
      font-size: 16px;
      .success{
        width: 24px;
        height: 24px;
        vertical-align: sub;
      }
    }
  }
  .success {
    width: 25px;
    height: 25px;
    vertical-align: middle;
  }
  .h1{
    color: #333;
    font-size: 15px;
    margin-bottom: 10px;
  }
  .yxlj-con{
    display: flex;
    align-items: center;
    div{
      display: flex;
      align-items: center;
      width: 80%;
      font-weight: normal;
    }
  }
  .con-1, .con-2{
    display: flex;
    justify-content: space-between;
    p {
      display: inline-block;
    }
  }
  .con-2{
    justify-content: start;
    .item1{
      width: 30%;
    }
    .item2, .item2 .p{
      width: 100%;
    }
  }
  .person-base-message {
    .p {
      .name {
        margin-right: 20px;
      }
      .year,.month {
        width: 200px;
        margin-left: 20px;
      }
    }
  }
  .p{
    display: flex;
    justify-content: start;
    i{
      display: inline-block;
    }
    .i-diy-width{
      width: 90px;
    }
    .i-diy-width +span{
      width: calc(100% - 150px);
    }
  }
}
.con:nth-of-type(5) {
  margin-bottom: 90px;
}
.btns{
  text-align: center;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0px;
  line-height: 80px;
  background: #f9fbff;
  width: 100%;
  z-index: 100;
}
</style>
<style lang='scss'>
.select-dicom-dialog {
  .el-dialog {
    height: auto;
    text-align: center;
    .el-dialog__body {
      padding-bottom: 10px;
      .table-search-form{
        margin-top: 8px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/resource/page/addcaseIndex.vue